import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { useEffect, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Stars } from "./Stars";
import { CollapsibleText } from "./CollapsibleText";
import type { ReviewCardProps } from "./ReviewCard.d";

dayjs.extend(relativeTime);

export const ReviewCard = ({ review, isHero, width = { base: "full", xl: "382px" }, ...props }: ReviewCardProps) => {
  const {
    consumer: { displayName, displayLocation },
    createdAt,
    text,
  } = review;
  const padding = isHero ? 8 : { base: 4, md: 6 };
  const [timeInWords, setTimeInWords] = useState("");

  useEffect(() => {
    if (createdAt) {
      setTimeInWords(dayjs(createdAt).fromNow());
    }
  }, [createdAt]);

  return (
    <Flex
      data-testid="review-card"
      w={width}
      bg="greyscale.100"
      p={padding}
      border="1px solid"
      borderColor="greyscale.400"
      borderRadius="lg"
      flexDir="column"
      justify="space-between"
      color="primary.900"
      {...props}
    >
      <Box mb={5}>
        <Flex justify="space-between" mb={9}>
          <Stars />
          <Text fontSize="sm" lineHeight="shorter" color="greyscale.600">
            {timeInWords}
          </Text>
        </Flex>
        {isHero ? (
          <Text fontSize="md" lineHeight="base">
            {text}
          </Text>
        ) : (
          <CollapsibleText text={text} />
        )}
      </Box>
      <Flex>
        <Flex flexDir="column" justify="center">
          <Text mb={0} fontSize="sm" lineHeight="base" fontWeight="semibold">
            {displayName}
          </Text>
          {displayLocation && (
            <Text fontSize="sm" lineHeight="base" color="greyscale.600">
              {displayLocation}
            </Text>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
